document.addEventListener("DOMContentLoaded", () => {
  const storage = localStorage.getItem("bar");
  // const storage = false;
  const bar = document.querySelector(".js-bar");
  const button = document.querySelector(".js-bar-btn");
  const header = document.querySelector(".header");

  const setBarHeight = () => {
    header.style.setProperty("--header-bar-height", bar ? `${bar.offsetHeight}px` : "0px");
  };

  if (bar && button) {
    if (!storage) {
      bar.classList.add("is-active");
      setBarHeight();

      button.addEventListener("click", () => {
        bar.remove();
        localStorage.setItem("bar", true);
        header.style.setProperty("--header-bar-height", "0px");
      });
    }
  }
})
